import * as React from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { AlertSpg, iTxt, OptionTableCell, SecurityGuard, SecurityRole, TableButton } from "@duosoftbg/nacid-components";
import PortalSearchTable from "../../../common/table/PortalSearchTable";
import { getI18n, useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { Fragment } from "react";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { openModal } from "../../../../../store/redux/slice/ComponentsControl/emailTemplatesControl";
import { useFormContext } from "react-hook-form";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "name",
    label: "l.table.head.name",
  },
  {
    id: "createdDate",
    label: "l.table.head.createdDate",
  },
  {
    id: "lastUpdateDate",
    label: "l.table.head.lastUpdateDate",
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];

const EmailTemplatesListTable = ({ total, records, blockTable, onPageOrOrderChange, group }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { getValues } = useFormContext();

  const handleOpenModal = (id, modalType) => {
    const payload = { id, modalType };
    dispatch(openModal(payload));
  };

  return (
    <Fragment>
      {total > 0 && (
        <PortalSearchTable
          group={group}
          headCells={headCells}
          total={total}
          blockTable={blockTable}
          onPageOrOrderChange={onPageOrOrderChange}
        >
          <TableBody>
            {records.map((row, index) => (
              <TableRow hover key={row.id}>
                <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
                <TableCell>{iTxt(getI18n().language, row.name, row.nameEn)}</TableCell>
                <TableCell>{row.createdDate}</TableCell>
                <TableCell>{row.lastUpdateDate}</TableCell>
                <OptionTableCell>
                  <TableButton type={"view"} onClick={() => handleOpenModal(row.id, "view")} />
                  <SecurityGuard checkForRoles={[SecurityRole.AcEmailTemplatesEdit]}>
                    <TableButton type={"edit"} onClick={() => handleOpenModal(row.id, "edit")} />
                  </SecurityGuard>
                  <SecurityGuard checkForRoles={[SecurityRole.AcEmailTemplatesDelete]}>
                    {row.id !== "BASE" && (
                      <TableButton type={"remove"} onClick={() => handleOpenModal(row.id, "delete")} />
                    )}
                  </SecurityGuard>
                </OptionTableCell>
              </TableRow>
            ))}
          </TableBody>
        </PortalSearchTable>
      )}
      {!(total > 0) && (
        <AlertSpg mt={10} mb={10} severity="info">
          {t("m.empty.list")}
        </AlertSpg>
      )}
      <SecurityGuard checkForRoles={[SecurityRole.AcEmailTemplatesEdit]}>
        <Button
          startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faAdd} />}
          size={"medium"}
          type={"button"}
          variant="contained"
          color="secondary"
          onClick={() => handleOpenModal("", "edit")}
        >
          {t("l.btn.create.template")}
        </Button>
      </SecurityGuard>
    </Fragment>
  );
};

export default EmailTemplatesListTable;
